import axios from 'axios'

export default class AjaxTabs {
  constructor(holder) {
    this.holder = holder
    if (!this.holder) return

    this.tabsList = this.holder.querySelector('.js-tabs-list')
    this.tabHolder = this.holder.querySelector('.js-tabs-holder')
    this.links = [...this.tabsList.querySelectorAll('.js-tabs-link')]
    this.search = this.holder.querySelector('.js-search-input')
    this.searchValue = ''
    this.searchReset = this.holder.querySelector('.js-search-input-reset')
    this.activeClass = 'active'
    this.category = this.holder.getAttribute('data-cat')
    this.view = 'all'
    this.page = 1
    this.url = ajax.url
    this.matchMedia = '(min-width: 960px)'
    this.device = ''

    this.loadTab()
    this.getDataWithSearch()
    this.attachEvents()
  }

  attachEvents() {
    this.links.forEach(link => {
      link.addEventListener('click', e => {
        e.preventDefault()
        this.page = 1

        this.resetInput()

        this.view = link.getAttribute('data-view')

        if (this.checkIfTabActive(link)) return

        this.removeActiveClassFromLinks()
        link.classList.add(this.activeClass)
        this.loadTab()
      })
    })

    this.resetSearch()
  }

  loadTab() {
    this.checkDevice()

    axios({
      method: 'post',
      url: `${this.url}=${this.searchValue}&action=search&view=${this.view}&category=${this.category}&page=${this.page}&show=${this.device}`
    }).then(response => {

      this.clearHolder()
      this.renderNewArticles(response.data)

    }).then(() => {
      let goToAll = document.querySelector('.js-link-reset')
      let searchValue = document.querySelector('.js-search-value')

      if (searchValue && this.searchValue) {
        searchValue.textContent = `f\u00fcr “${this.searchValue}”`
      }

      if (goToAll) {
        goToAll.addEventListener('click', e => {
          e.preventDefault()

          this.resetAllFilters()
        })
      }

      this.paginationEvents()
    })
  }

  checkIfTabActive(link) {
    return link.classList.contains(this.activeClass)
  }

  removeActiveClassFromLinks() {
    this.links.forEach(link => {
      link.classList.remove(this.activeClass)
    })
  }

  clearHolder() {
    this.tabHolder.innerHTML = ''
  }

  renderNewArticles(data) {
    this.tabHolder.insertAdjacentHTML('beforeend', data)
  }

  getCounter(link) {
    return link.dataset.count
  }

  resetAllFilters() {
    this.resetInput()
    this.view = 'all'

    this.links.forEach((link, i) => {
      link.classList.remove(this.activeClass)

      if (i === 0) {
        link.classList.add(this.activeClass)
      }
    })

    axios({
      method: 'post',
      url: `${this.url}=&action=search&view=${this.view}&category=${this.category}&page=1&show=${this.device}`,
    }).then(response => {
      this.clearHolder()
      this.renderNewArticles(response.data)
    }).then(() => {
      this.paginationEvents()
    })
  }

  resetInput() {
    this.searchValue = ''
    this.search.value = ''
    if (this.search.parentElement.classList.contains('js-search-focused')) {
      this.search.parentElement.classList.remove('js-search-focused')
    }
  }

  resetSearch() {
    this.searchReset.addEventListener('click', () => {
      this.searchValue = ''
      this.loadTab()
    })
  }

  getDataWithSearch() {
    this.search.addEventListener('keyup', () => {
      this.page = 1
      this.searchValue = this.search.value
      this.loadTab()
    })
  }

  paginationEvents() {
    let pages = [...document.querySelectorAll('.page-numbers')]

    pages.forEach(page => {
      page.addEventListener('click', e => {
        e.preventDefault()

        this.holder.scrollIntoView({ behavior: 'smooth' })

        let currentPage

        pages.forEach(el => {
          if (el.classList.contains('current')) {
            currentPage = +el.textContent
          }
          el.classList.remove('current')
        })

        if (!page.classList.contains('next') && !page.classList.contains('prev')) {
          this.page = +page.textContent
          page.classList.add('current')
        }

        if (page.classList.contains('next')) {
          this.page = currentPage + 1
        }

        if (page.classList.contains('prev')) {
          this.page = currentPage - 1
        }

        this.loadTab()
      })
    })
  }

  checkDevice() {
    if (!window.matchMedia(this.matchMedia).matches) {
      this.device = 'mobile'
    }
  }
}